import { Injectable, Type, inject } from '@angular/core';

import { SitecoreMyBetsConfig, SportsUserSettings } from '@frontend/sports/common/client-config-data-access';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { BetModalComponent } from './bet-modal.component';
import { BetModalModule } from './bet-modal.module';

@Injectable({ providedIn: 'root' })
export class BetModalComponentLoaderService extends ComponentLoaderService<BetModalModule> {
    private sitecoreMyBets = inject(SitecoreMyBetsConfig);
    private userSettings = inject(SportsUserSettings);

    moduleName = 'BetModalModule';

    constructor() {
        const moduleLoader = inject(ModuleLoaderService);
        const loggerFactory = inject(LoggerFactory);

        super(moduleLoader, loggerFactory);
    }

    getBetModalComponent(): ComponentProxy<BetModalComponent> {
        //why undefined ?
        return this.getComponentProxy((module) => module.betModalComponent, undefined, this.sitecoreMyBets, this.userSettings);
    }

    getModule(): Promise<Type<BetModalModule>> {
        return import('./bet-modal.module').then((m) => m.BetModalModule);
    }
}
